import './Section.scss';
import Card from 'react-bootstrap/Card';

/* Similar to Panel but without close functionality and focus styling*/

export default function Section({ children, title, className = '', style }) {

    return (
        <Card className={`section ${className}`} data-testid='section-card' style={style}>
            <Card.Body>
                <Card.Title className='d-flex justify-content-between align-items-right'>
                    {title}
                </Card.Title>
                <div className='section-content'>
                    {children}
                </div >
            </Card.Body>
        </Card>
    )
}